export enum ApproverType {
  ORG_ADMIN = 'ORG_ADMIN',
  FACILITY_APPROVERS = 'FACILITY_APPROVERS',
  CATEGORY_APPROVERS = 'CATEGORY_APPROVERS',
  SEQUENCE_APPROVERS = 'SEQUENCE_APPROVERS',
}

export interface ApprovalFlowOrderItem {
  id: string;
  approverType: ApproverType;
  order: number;
}

export interface ApprovalFlowOrderResponse {
  id: string;
  schoolId: string;
  items: ApprovalFlowOrderItem[];
}

export interface UpdateApprovalFlowOrderItem {
  approverType: ApproverType;
  order: number;
}

export interface UpdateApprovalFlowOrderRequest {
  items: UpdateApprovalFlowOrderItem[];
}

